export const slideshowData = [
  {
    image: "https://i.imgur.com/xpKUjHI.jpeg",
    title: "Precision Dental Manufacturing",
    subtitle: "State-of-the-art laboratory equipment and expert craftsmanship"
  },
  {
    image: "https://i.imgur.com/wiQxoiC.jpeg",
    title: "Premium Dental Devices",
    subtitle: "Custom crowns, bridges, and prosthetics crafted to perfection"
  },
  {
    image: "https://i.imgur.com/vzYvB9N.jpeg",
    title: "Advanced Digital Solutions",
    subtitle: "Cutting-edge technology for superior dental solutions"
  },
  {
    image: "https://i.imgur.com/wVM5LMC.jpeg",
    title: "Quality Assurance",
    subtitle: "Rigorous testing ensures exceptional quality and reliability"
  },
  {
    image: "https://i.imgur.com/t7yh6SS.jpeg",
    title: "Excellence in Every Detail",
    subtitle: "Dedicated to delivering the highest standards in dental craftsmanship"
  }
];